import React, { useEffect, useState } from 'react';
import { ContentSectionDetail } from '.';
import { Carousel } from '@mantine/carousel';
import ContentItem from './ContentItem';
import styles from './styles.module.scss';
import { useMediaQuery } from '@mantine/hooks';
import { BreakpointPreview } from '../../../types/configuration';

interface ContentCarouselProps {
  data: ContentSectionDetail[];
  isCarousel?: 'Y' | 'N' | null;
  isHomepage?: boolean;
  isPreview?: boolean;
  breakpoint?: BreakpointPreview;
}
const ContentCarousel: React.FC<ContentCarouselProps> = ({
  data,
  isHomepage,
  isCarousel,
  isPreview,
  breakpoint
}) => {
  const xsScreen = useMediaQuery('(max-width: 30em)');
  const smScreen = useMediaQuery('(max-width: 48em)');
  const mdScreen = useMediaQuery('(max-width: 64em)');
  const lgScreen = useMediaQuery('(max-width: 74em)');
  const xlScreen = useMediaQuery('(max-width: 88em)');

  const size = () => {
    if (smScreen || mdScreen) {
      return (100 / 2).toString();
    } else if (lgScreen) {
      return (100 / 3).toString();
    } else {
      return (100 / 4).toString();
    }
  };
  const publishSlideSize = { base: '100%', sm: size() + '%' };
  const previewMobileSlideSize = { base: '100%' };
  const previewDesktopSlideSize = {
    base: '100%',
    sm: (100 / 3).toString() + '%'
  };

  const publishSlideGap = { base: 0, sm: 'xs', lg: 'md' };
  const previewMobileSlideGap = { base: 0 };
  const previewDesktopSlideGap = { base: 0, sm: 12 };

  const [slideSize, setSlideSize] = useState<any>(publishSlideSize);
  const [slideGap, setSlideGap] = useState<any>(publishSlideGap);
  const [slidesScroll, setSlidesScroll] = useState<any>(1);

  useEffect(() => {
    if (isPreview) {
      if (breakpoint === 'mobile') {
        setSlideSize(previewMobileSlideSize);
        setSlideGap(previewMobileSlideGap);
        setSlidesScroll(1);
      } else {
        setSlideSize(previewDesktopSlideSize);
        setSlideGap(previewDesktopSlideGap);
        setSlidesScroll(3);
      }
    } else {
      if (xsScreen) {
        setSlidesScroll(1);
      } else if (smScreen || mdScreen) {
        setSlidesScroll(2);
      } else if (lgScreen) {
        setSlidesScroll(3);
      } else {
        setSlidesScroll(4);
      }
      setSlideSize(publishSlideSize);
      setSlideGap(publishSlideGap);
    }
  }, [isPreview, breakpoint, xsScreen, smScreen, mdScreen, lgScreen, xlScreen]);

  return (
    <>
      <Carousel
        withIndicators={data.length > 1}
        classNames={styles}
        loop
        align="start"
        slideSize={slideSize}
        slideGap={slideGap}
        slidesToScroll={slidesScroll}
        withControls={data.length > 1}
        py={12}
        mb={10}
      >
        {data.map((item: ContentSectionDetail, index: number) => {
          return (
            <Carousel.Slide key={index}>
              <ContentItem {...item} isCarousel={isCarousel} />
            </Carousel.Slide>
          );
        })}
      </Carousel>
    </>
  );
};

export default ContentCarousel;
